// extracted by mini-css-extract-plugin
export default {"card":"CardSection_card__jGeMx","label":"CardSection_label__7Qddr","image":"CardSection_image__Y61sx"};